var map = {
	"./news/new-form": [
		"8ced",
		"chunk-b550f80a",
		"chunk-7c51e9a2"
	],
	"./partners/partner-form": [
		"314e",
		"chunk-3b91ea22"
	],
	"./users/user-form": [
		"ddb6",
		"chunk-b550f80a",
		"chunk-2d22998a"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "f6c6";
module.exports = webpackAsyncContext;